import { createMask } from '@ngneat/input-mask';

export function createTwoFaMask() {
  return createMask({
    mask: ['999 999', '-9'],
    placeholder: '',
    autoUnmask: true,
    allowMinus: true,
  });
}

export function createNumericMask(digits?: number) {
  return createMask({
    alias: 'numeric',
    groupSeparator: ',',
    inputmode: 'decimal',
    rightAlign: false,
    allowMinus: false,
    autoUnmask: true,
    ...(digits !== undefined && { digits }),
  });
}
